import { render, staticRenderFns } from "./edit-info.vue?vue&type=template&id=60902a56&scoped=true&"
import script from "./edit-info.vue?vue&type=script&lang=js&"
export * from "./edit-info.vue?vue&type=script&lang=js&"
import style0 from "./edit-info.vue?vue&type=style&index=0&id=60902a56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60902a56",
  null
  
)

export default component.exports